<template>
    <div>
        <breadcrumb :routerList="[{to:'/basic/role',title:'角色管理'},{title:'角色授权'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2" style="padding:0">
                                    <div class="h-formLine">
                                        <el-form :model="formLabelAlign" label-position="right" ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="角色编码" class="h-elformWrap-2"  >
                                                <el-input v-model="formLabelAlign.id" readonly  ></el-input>
                                            </el-form-item>
                                            <el-form-item label="角色名称" class="h-elformWrap-2"  >
                                                <el-input v-model="formLabelAlign.name" readonly  ></el-input>
                                            </el-form-item>
                                            <el-form-item label="描述" class="h-elformWrap-1"  >
                                                <el-input v-model="formLabelAlign.des" readonly  ></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width: 45%;">
                    <div class="h-rowBox">
                        <div class="h-rowTitle">
                            <div class="h-disTable">
                                <div class="h-tableCell">
                                    <h1>角色绑定的资源</h1>
                                </div>
                                <el-button type="primary" @click="saveRoleRes" style="margin-top: 5px;">保存</el-button>
                            </div>
                        </div>
                        <div class="h-rowCon">
                            <vtree :data="treedata"
                                   ref="tree"
                                   size="small"
                                   text-field-name="name"
                                   value-field-name="code"
                                   children-field-name="children"
                                   show-checkbox
                                   multiple/>
                        </div>
                    </div>
                </div>
                <div class="h-rowIn" style="width: 55%;">
                    <div class="h-rowBox">
                        <div class="h-rowTitle">
                            <div class="h-disTable">
                                <div class="h-tableCell">
                                    <h1>角色下的人员信息</h1>
                                </div>
                            </div>
                        </div>
                        <div class="h-rowCon">
                            <div class="h-formBox" style="margin-bottom: 1px;">
                                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                                    <el-form-item label="用户账号/姓名">
                                        <el-input clearable v-model="q.usercodeLikeusernameLike"></el-input>
                                    </el-form-item>
                                    <el-form-item class="h-formBtnOut">
                                        <el-button type="primary"  icon="el-icon-search" @click="handleFilter">搜索</el-button>
                                        <el-button type="primary" @click="selectUser"  icon="el-icon-plus"></el-button>
                                        <el-button type="primary" @click="removeuser"  icon="el-icon-delete"></el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <el-table
                                    ref="multipleTable"
                                    :data="ttdata"
                                    tooltip-effect="dark"
                                    style="width: 100%"
                                    @selection-change="handleSelectionChange">
                                <el-table-column
                                        type="selection"
                                        width="55">
                                </el-table-column>
                                <el-table-column
                                        prop="usercode"
                                        label="账号"
                                        width="150"
										:show-overflow-tooltip="true">
                                    <template scope="scope">
                                        <a href="javascript:;" @click="openDialogUserdata(scope.row.usercode)">{{scope.row.usercode}}</a>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="username"
                                        label="姓名"
                                        width="150"
										:show-overflow-tooltip="true">
                                </el-table-column>
                                <el-table-column
                                        prop="email"
                                        label="邮箱"
										:show-overflow-tooltip="true">
                                </el-table-column>
                                <el-table-column
                                        prop="usertype"
                                        label="用户类型"
										:show-overflow-tooltip="true">
                                    <template slot-scope="scope">
                                        <dictname category="yonghu_leixing" :v="scope.row.usertype"/>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                                <paginationmin :page="q" @query="queryUser"/>
                            </div>
                        </div>
                    </div>
                </div>


            </div>


            <alluser :visible.sync="visible" @choseUser="choseUser" title="选择用户"/>
            <el-dialog
                    title="用户数据集权限"
                    :visible.sync="userdatagrantdialogVisible"
                    v-if="userdatagrantdialogVisible"
                    width="80%">
                <userdatagrant :usercode="usercode"/>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import _ from 'loadsh'
    import ss from '../../api/SystemService'
    import alluser from '../../components/dialog/alluser'
    import userdatagrant from '../../components/basic/userdatagrant'
    export default {
        components:{alluser,userdatagrant},
        data(){
            return{
                visible: false,
                userdatagrantdialogVisible:false,
                usercode:null,
                //查询属性
                page:{

                },
                q:{
                    roleid:this.$route.query.id,
                    usernameLikeusernameLike:null,
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                formLabelAlign:{},
                ttdata: [],
                treedata: null,
                users:null,
            }
        },
        methods:{
            handleFilter(){
              this.queryUser();
            },
            queryUser(p){
                ss.RoleService.getAllUsersByRoleidPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.ttdata = rd.records;
                })
            },
            openDialogUserdata(d){
                this.usercode = d;
                this.userdatagrantdialogVisible = true;
            },
            queryTree(){
                ss.ResourceService.getAllResCheckedByRoleId(this.$route.query.id).then(rd=>{
                    this.treedata = rd;
                })
            },
            selectUser(){
                this.visible = true;
            },
            choseUser(users){
                if(users.length>0){
                    var uids = _.map(users, 'usercode').join(",");
                    ss.RoleService.bindRoleuser({roleid:this.formLabelAlign.id,userids:uids,optflag:"add"}).then(rd=>{
                        this.queryUser();
                        this.$msg.msgs("添加成功");
                    })
                    this.visible = false;
                }else{
                    this.$msg.msge("至少选择一条数据")
                }

            },
            removeuser(){
                this.$msg.confirm("确认删除",()=>{
                    var uids = _.map(this.users, 'usercode').join(",");
                    ss.RoleService.bindRoleuser({roleid:this.formLabelAlign.id,userids:uids,optflag:"del"}).then(rd=>{
                        this.queryUser();
                    })
                })
            },
            // 点击弹框下的取消
            handleCancel(){
                this.dialogVisible = false;
            },
            //关闭弹窗
            handleCloseBindWarnStandard(){
                this.dialogVisible = false;
            },
            //拍品新增、修改弹窗提交
            submitForm(val) {
                this.visible = false;

            },
            saveRoleRes(){
                this.$msg.confirm("确认提交",()=>{
                    var dd = this.$refs['tree'].data;
                    const item = this.findAll(dd)
                    ss.RoleService.bindRoleres({roleid:this.formLabelAlign.id,resids:item.join(",")}).then(rd=>{
                        this.queryTree();
                        this.$msg.msgs("添加成功");
                    })
                })
            },
            handleSelectionChange(users){
                this.users = users;
            },
            findAll(items) {
                var  result = [];
                for (var i=0; i < items.length; i++) {
                    if (items[i].selected ) {
                        result.push(items[i].id);
                    }
                    var found = this.findAll(items[i].children);
                    if (found.length) {
                        result = result.concat(found);
                    }
                }
                return result;
            }
        },
        created(){
            this.formLabelAlign = this.$route.query;
            this.queryUser();
            this.queryTree();

        },
        mounted(){
        },
    }
</script>
<style scoped>
    .el-dialog__body{
        padding-top: 0px!important;
    }
</style>
